import { Box, Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import { useSearchParamsObject } from 'utils'
import { AuthFormTitle } from '../AuthFormTitle/AuthFormTitle'
import { AuthLogo } from '../AuthLogo/AuthLogo'
import { CancelRegistrationModal } from './CancelRegistrationModal'

export const AuthPageSuccessSubscription = () => {
  const { type, payment_failed } = useSearchParamsObject()
  const navigate = useNavigate()
  const [cancelOpen, setCancelOpen] = useState(false)

  const onClick = () => navigate(routes.signIn)

  if (payment_failed === 'true') {
    return (
      <Box display="flex" flexDirection="column" alignItems="center">
        <AuthLogo mb={2} />
        <AuthFormTitle mb={2}>Your account has been created!</AuthFormTitle>

        <Typography textAlign="center" color="grey.700">
          Your payment could not be processed. Please sign in and go to{' '}
          <strong>My Subscription</strong> to complete your payment and activate full access.
        </Typography>

        <Button variant="contained" onClick={onClick} sx={{ mt: 4, minWidth: 160 }}>
          Go to Sign In
        </Button>

        {/* The account exists but has no access — offer to remove it so the email is free again. */}
        <Button
          variant="text"
          color="info"
          onClick={() => setCancelOpen(true)}
          sx={{ mt: 1, minWidth: 160 }}
        >
          Cancel registration
        </Button>

        <CancelRegistrationModal
          isOpen={cancelOpen}
          onClose={() => setCancelOpen(false)}
          onDeleted={() => {
            setCancelOpen(false)
            navigate(routes.signUp)
          }}
        />
      </Box>
    )
  }

  const text =
    type === 'trainee'
      ? 'You can now access the Training Software via your email and password.'
      : 'You can now access the system via your email and password.'

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <AuthLogo mb={2} />
      <AuthFormTitle mb={2}>Your payment was successful!</AuthFormTitle>

      <Typography textAlign="center" color="grey.700">
        {text}
      </Typography>

      <Button variant="contained" onClick={onClick} sx={{ mt: 4, minWidth: 160 }}>
        Go to Sign In
      </Button>
    </Box>
  )
}
